import { computed, Injectable, signal } from '@angular/core';

export const LEFT_PANEL_WIDTH = 420;

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  public static readonly LEFT_PANEL_WIDTH = 420;

  public hasOpenedMenu = signal<boolean>(JSON.parse(window.localStorage.getItem('hasOpenedMenu')));
  public hasOpenedLeftPanel = signal<boolean>(true);
  public hasExtendedLeftPanel = signal<boolean>(false);

  public navigationWidth = signal<number>(0);
  public leftPanelWidth = signal<number>(0);
  public leftMapOffset = computed(() => {
    return this.hasOpenedLeftPanel()
      ? this.navigationWidth() + this.leftPanelWidth()
      : this.navigationWidth();
  });

  // The top offset for the map, accounting for the navigation bar height and banner if present
  public topMapOffset = signal<number>(0);

  toggleMenu() {
    this.hasOpenedMenu.set(!this.hasOpenedMenu());
    window.localStorage.setItem('hasOpenedMenu', this.hasOpenedMenu().toString());
  }

  toggleLeftPanel() {
    this.hasOpenedLeftPanel.set(!this.hasOpenedLeftPanel());
  }

  toggleExtendedLeftPanel() {
    this.hasExtendedLeftPanel.set(!this.hasExtendedLeftPanel());
  }
}
